var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 3.333c.46 0 .833.373.833.834v11.666a.833.833 0 0 1-1.666 0V4.167c0-.46.373-.834.833-.834"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.577 9.41a.833.833 0 0 1 1.179 0L10 14.656l5.244-5.244a.833.833 0 0 1 1.179 1.178l-5.834 5.833a.833.833 0 0 1-1.178 0L3.577 10.59a.833.833 0 0 1 0-1.178Z"
  })));
};
export default SvgArrowDown;